module.exports = __webpack_public_path__ + "static/Hero-7b817044a46651fe11aa49751466112b.png";